import { Slide } from "react-reveal";

const AppDevelopmentOffers = () => {
  return (
    <section className="solution-item-section section-spacing-50 world-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="solution-offers-container flex">
              <div className="solution-offers-textside">
                <div className="section-head width-600 section-spacing-40 no-padding-top">
                  <p className="section-tag boldTitle">OFFERS</p>
                  <Slide top>
                    <h2 className="section-title ntuna-text-fill">
                      What's Included
                    </h2>
                  </Slide>
                  <p className="section-subtitle font-inter-regular">
                    We don't build generic apps. Every mobile app is
                    custom-designed and developed to match your business and
                    use-case goals - ensuring high-performance, scalability, and
                    a seamless user experience across all devices.
                  </p>
                </div>
                <div className="section-body">
                  <ul className="offers-list-container">
                    <li className="offers-list">
                      <h3>App Strategy & Architecture</h3>
                      <ul>
                        <li>
                          <span>App idea consultation & validation</span>
                        </li>
                        <li>
                          <span>Feature planning & system architecture</span>
                        </li>
                        <li>
                          <span>User flow & journey mapping</span>
                        </li>
                        <li>
                          <span>Technology stack selection</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>User Interface & Experience Design</h3>
                      <ul>
                        <li>
                          <span>Mobile-first interface design</span>
                        </li>
                        <li>
                          <span>Intuitive user experience</span>
                        </li>
                        <li>
                          <span>Wireframes & interactive prototypes</span>
                        </li>
                        <li>
                          <span>Brand-aligned app design</span>
                        </li>
                        <li>
                          <span>Usability optimization</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>App Development</h3>
                      <ul>
                        <li>
                          <span>Android app development</span>
                        </li>
                        <li>
                          <span>iOS app development</span>
                        </li>
                        <li>
                          <span>Cross-platform development</span>
                        </li>
                        <li>
                          <span>
                            Feature-rich, business driven functionality
                          </span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Backend systems & core components</h3>
                      <ul>
                        <li>
                          <span>Backend architecture & server-side logic</span>
                        </li>
                        <li>
                          <span>API development & integration</span>
                        </li>
                        <li>
                          <span>Database design & management</span>
                        </li>
                        <li>
                          <span>
                            User authentication (registration, roles, access)
                          </span>
                        </li>
                        <li>
                          <span>Real-time data synchronization</span>
                        </li>
                        <li>
                          <span>Analytics integrations</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Integration & Business Connectivity</h3>
                      <ul>
                        <li>
                          <span>
                            Payment integrations(Subscriptions & billing
                            systems)
                          </span>
                        </li>
                        <li>
                          <span>Integration with existing systems</span>
                        </li>
                        <li>
                          <span>
                            Third-party APIs(CRM, ERP, analytics tools)
                          </span>
                        </li>
                        <li>
                          <span>SMS, email & notifications systems</span>
                        </li>
                        <li>
                          <span>External services & platform integrations</span>
                        </li>
                        <li>
                          <span>In-app chat & communication systems</span>
                        </li>
                        <li>
                          <span>Multi-language support</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Performance & Security</h3>
                      <ul>
                        <li>
                          <span>
                            High-performance optimization (Speed,
                            responsiveness)
                          </span>
                        </li>
                        <li>
                          <span>
                            Secure authentication & authorization systems
                          </span>
                        </li>
                        <li>
                          <span>Data encryption & secure storage</span>
                        </li>
                        <li>
                          <span>App stability & crash prevention</span>
                        </li>
                        <li>
                          <span>Secure API communication</span>
                        </li>
                        <li>
                          <span>Scalable infrastructure</span>
                        </li>
                        <li>
                          <span>Offline functionality</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Testing & Quality Assurance</h3>
                      <ul>
                        <li>
                          <span>Functional testing across features</span>
                        </li>
                        <li>
                          <span>Device & screen compatibility testing</span>
                        </li>
                        <li>
                          <span>Performance & load testing</span>
                        </li>
                        <li>
                          <span>Bug detection, fixing & resolution</span>
                        </li>
                        <li>
                          <span>User experience validation</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Deployment & App store launch</h3>
                      <ul>
                        <li>
                          <span>Google play store publishing</span>
                        </li>
                        <li>
                          <span>Apple app store submission</span>
                        </li>
                        <li>
                          <span>App store compliance & approval handling</span>
                        </li>
                        <li>
                          <span>App listing optimization (ASO basics)</span>
                        </li>
                        <li>
                          <span>Version control & release management</span>
                        </li>
                      </ul>
                    </li>
                    <li className="offers-list">
                      <h3>Training, Support & Maintenance</h3>
                      <ul>
                        <li>
                          <span>Team training & app usage</span>
                        </li>
                        <li>
                          <span>Documentation & user guides</span>
                        </li>
                        <li>
                          <span>Ongoing technical support</span>
                        </li>
                        <li>
                          <span>App monitoring & maintenance</span>
                        </li>
                        <li>
                          <span>Updates & feature improvements</span>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppDevelopmentOffers;
